import { render, staticRenderFns } from "./RedemptionInvoice.vue?vue&type=template&id=d535dea6"
import script from "./RedemptionInvoice.vue?vue&type=script&lang=js"
export * from "./RedemptionInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports